import { firstExamResponse } from './examResponseUtils';

const isExplicitFalse = (value) => (
  value === false
  || value === 'false'
  || value === 0
  || value === '0'
);

export const getExamConfiguration = (response) => {
  const academyExam = firstExamResponse(response);
  return academyExam?.exam || academyExam?.academyExam?.exam || academyExam || null;
};

/**
 * Legacy exams have no monitoringRequired value. Returning true for every
 * missing value preserves the existing monitored experience and makes failures
 * fail closed on the learner side.
 */
export const resolveMonitoringRequired = (candidate) => {
  const exam = candidate?.exam && candidate.monitoringRequired === undefined
    ? candidate.exam
    : candidate;
  return !isExplicitFalse(exam?.monitoringRequired);
};

export const isAcademyExam = (candidate) => {
  const exam = candidate?.exam || candidate;
  return !exam?.type || exam.type === 'Academy' || exam.type === 'ACADEMY';
};
